import React, { useState } from "react";
import { Button, Form, Input, Modal } from "antd";
import { CheckCircleFilled } from "@ant-design/icons";
import { Link, useNavigate } from "react-router-dom";
import TextArea from "antd/es/input/TextArea";
import {
  useGetImagePortfolioMutation,
  useDeleteImagePortfolioMutation,
  usePostCreatePortfolioMutation,
  useGetPortfolioMutation,
  usePostUploadImagePortfolioMutation,
} from "./services/PortfolioSerivce/PortfolioService";
import middlewareAuthenticator from "./utils/middlewareAuthenticator";
import LocalStorageService from "./utils/LocalStorageService";
import { BASE_URL } from "./constans/PathConfig";

type FormPortType = {
  description: string;
  title: string;
  url_website: string;
};

const BackAdmin = () => {
  const navigate = useNavigate();
  const [imageUrl, setImageUrl] = useState<string>();
  const [form] = Form.useForm();
  const [modal, contextHolder] = Modal.useModal();

  const [image_profile_url, setImageProfileUrl] = useState<string>();
  const [selectedFile, setSelectedFile] = useState<File | null>(null);
  const [file_image, setFileImage] = useState("");
  const token = LocalStorageService.getAccessToken();
  const [postCreatePortfolio, result_create_port] =
    usePostCreatePortfolioMutation();

  const [uploadImagePort, result_upload_image] =
    usePostUploadImagePortfolioMutation();

  const handleUpload2 = async () => {
    try {
      if (selectedFile) {
        const result = await uploadImagePort(selectedFile).unwrap();
        if (result.status === 200) {
          setImageProfileUrl(result.data?.url_image);
          // console.log("Upload Success", result.data);
        }
      }
    } catch (err) {
      return;
      // console.error("Error uploading file:", err);
    }
  };

  const handleFileChange2 = (event: React.ChangeEvent<HTMLInputElement>) => {
    if (event.target.files && event.target.files.length > 0) {
      const file: File = event.target.files[0];
      setSelectedFile(file);
      setFileImage(URL.createObjectURL(file));
    }
  };

  const fnCreatePortfolio = async (
    title: string,
    url_website: string,
    description: string,
    image: string
  ) => {
    try {
      const result = await postCreatePortfolio({
        image,
        description,
        url_website,
        title,
      }).unwrap();
    } catch (err) {
      return;
    }
  };

  const onFinish = (values: FormPortType) => {
    if (image_profile_url) {
      fnCreatePortfolio(
        values.title,
        values.url_website,
        values.description,
        image_profile_url
      );
    }
  };

  const onFinishFailed = (errorInfo: any) => {
    // console.log("Failed:", errorInfo);
  };

  const logOut = () => {
    navigate("/back-login");
    LocalStorageService.clearAccessToken();
  };

  const config = {
    title: "Delete?",
    content: null,
    closable: true,
  };

  const config_modal_logout = {
    title: "Logout?",
    content: null,
    closable: true,
  };

  const data_route = [
    {
      path: "/",
      title: "Home",
    },
    {
      path: "/back-admin",
      title: "Admin",
    },
    {
      path: "/back-admin/edit-data",
      title: "Edit data",
    },
    {
      path: "/back-admin/edit-image-design",
      title: "Image Design",
    },
  ];

  return (
    <div className="flex flex-col items-center py-[30px]">
      <div className="flex flex-row items-start mx-[20px] max-w-[700px] w-full mb-[10px] justify-between xs:flex-col gap-[10px]">
        <div className="flex flex-row gap-[10px]">
          {data_route.map((item) => (
            <>
              <Link
                key={item.title}
                to={item.path}
                className="bg-custom-primary-100 text-[14px] px-[10px] rounded-[5px] hover:bg-white text-white hover:text-custom-gray-100 duration-200"
              >
                {item.title}
              </Link>
            </>
          ))}
        </div>

        <button
          onClick={async () => {
            const confirmed = await modal.confirm(config_modal_logout);
            if (confirmed) {
              logOut();
            }
          }}
          className="bg-white text-[14px] px-[10px] rounded-[5px] text-custom-primary-100 hover:text-white duration-200 hover:bg-custom-primary-100 "
        >
          Logout
        </button>
      </div>

      <div className="flex flex-col items-center bg-custom-primary-25 w-full max-w-[700px] p-[20px] rounded-[15px]">
        Upload Portfolio
        <div className="flex flex-col w-full gap-[10px]">
          <input type="file" onChange={handleFileChange2} />
          {/* Upload Image */}
          {file_image.length !== 0 ? (
            <>
              <img
                src={file_image}
                className="w-[200px] h-full rounded-[10px]"
              />
              <Button
                onClick={handleUpload2}
                className="bg-white px-[10px] rounded-[5px] w-[200px] hover:bg-slate-200 flex items-center justify-center"
                loading={result_upload_image.isLoading}
              >
                {result_upload_image.isSuccess ? (
                  <CheckCircleFilled className="text-green-400" />
                ) : (
                  ""
                )}{" "}
                Upload
              </Button>
            </>
          ) : (
            <></>
          )}
        </div>
        <Form
          form={form}
          name="basic"
          layout="vertical"
          style={{ width: "100%" }}
          initialValues={{ remember: true }}
          onFinish={onFinish}
          onFinishFailed={onFinishFailed}
          autoComplete="off"
          encType="multipart/form-data"
        >
          <Form.Item
            label="Title Website"
            name="title"
            hasFeedback={false}
            required={false}
            style={{
              width: "100%",
              marginBottom: 0,
            }}
            className="mt-[20px]"
            rules={[
              {
                required: true,
                message: "Please enter title",
              },
            ]}
          >
            <Input id="title" />
          </Form.Item>

          <Form.Item
            label="URL"
            name="url_website"
            hasFeedback={false}
            required={false}
            style={{
              width: "100%",
              marginBottom: 0,
            }}
            rules={[
              {
                required: true,
                message: "Please enter URL",
              },
            ]}
          >
            <Input id="url_website" />
          </Form.Item>

          <Form.Item
            label="Description"
            name="description"
            hasFeedback={false}
            required={false}
            style={{
              width: "100%",
              marginBottom: 0,
            }}
            rules={[
              {
                required: true,
                message: "Please enter description",
              },
            ]}
          >
            <TextArea rows={4} id="description" />
          </Form.Item>
          <div className="flex gap-[10px]">
            <Button
              loading={result_create_port.isLoading}
              type="primary"
              htmlType="submit"
              className="bg-custom-primary-100 mt-[10px] hover:!bg-custom-primary-75 flex justify-center items-center"
              // disabled={true}
            >
              {result_create_port.isSuccess ? (
                <CheckCircleFilled className="text-white" />
              ) : (
                ""
              )}{" "}
              Submit
            </Button>

            <Button
              type="primary"
              className="!bg-white mt-[10px] text-custom-primary-75 hover:!bg-custom-primary-75"
              onClick={() => {
                form.resetFields();
                setImageProfileUrl("");
              }}
            >
              Clear
            </Button>
          </div>
        </Form>
      </div>
      {contextHolder}
    </div>
  );
};

export default middlewareAuthenticator(BackAdmin, { pageAction: "USE_AUTH" });
